import React from "react";
import { Snackbar, Alert } from "@mui/material";

const getSnackbarColor = (type) => {
  switch (type) {
    case "success":
      return { backgroundColor: "#F2FBF9", color: "#2B2B2B", border: "1px solid #00B190", fontWeight: '400px', fontFamily: 'Unilever Shilling', fontSize: '12px' };
    default:
      return undefined;
  }
};


const SnackBarMessage = ({ type, snackbarMessage, snackbarOpen, setSnackbarOpen }) => {

  const handleClose = (event) => {
    if (setSnackbarOpen) {
      setSnackbarOpen(false);
    }
  };

  return (
    <Snackbar open={snackbarOpen} autoHideDuration={15000} onClose={handleClose} anchorOrigin={{ vertical: 'top', horizontal: 'center' }}>
      <Alert elevation={6} variant="filled" severity={type} onClose={handleClose} sx={getSnackbarColor(type)}>
        {/* {snackbarMessage} */}
        <span dangerouslySetInnerHTML={{ __html: snackbarMessage }} />
      </Alert>
    </Snackbar>
  );
};

export default SnackBarMessage;
